"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImportPoleforemanButton = exports.CSS = void 0;
const index_1 = require("../../i18n/index");
const mithril_1 = require("../../mithril");
const theme_1 = require("../theme");
exports.CSS = {
    container: 'c-Import-Poleforeman-Button',
    MDL: {
        container: 'mdl-button mdl-button--icon'
    }
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        position: 'fixed',
        bottom: '240px',
        right: '7.7%',
        'z-index': 5,
        width: '64px',
        height: '64px',
        'background-image': (0, theme_1.assetURL)('/images/poleforeman_logo.svg'),
        'background-size': '100%',
        'background-repeat': 'no-repeat',
        'background-position': 'center'
    }
});
exports.ImportPoleforemanButton = {
    view(ctx = {}) {
        return (0, mithril_1.m)('button', {
            className: `${exports.CSS.container} ${exports.CSS.MDL.container}`,
            disabled: ctx.disabled,
            title: (0, index_1.Translate)(ctx.title),
            onclick: ctx.onclick
        });
    }
};
//# sourceMappingURL=import-poleforeman.button.js.map